import browserHistory from 'react-router/lib/browserHistory'
import { push, replace } from 'react-router-redux'
import { takeEvery, put, all } from 'redux-saga/effects'

// ------------------------------------
// Constants
// ------------------------------------
export const LOCATION_CHANGE = 'LOCATION_CHANGE'
export const PUSH_LOCATION = 'PUSH_LOCATION'
export const REPLACE_LOCATION = 'REPLACE_LOCATION'

// ------------------------------------
// Actions
// ------------------------------------
export function locationChange(location = '/') {
  return {
    type: LOCATION_CHANGE,
    payload: location
  }
}

export const pushLocation = (location = '/') => ({
  type: PUSH_LOCATION,
  location
})

export const replaceLocation = (location = '/') => ({
  type: REPLACE_LOCATION,
  location
})

// ------------------------------------
// Specialized Action Creator
// ------------------------------------
export const updateLocation = ({ dispatch }) => {
  return nextLocation => dispatch(locationChange(nextLocation))
}

// ------------------------------------
// Reducer
// ------------------------------------
const initialState = browserHistory.getCurrentLocation()
export default function locationReducer(state = initialState, action) {
  return action.type === LOCATION_CHANGE ? action.payload : state
}

function* locationPusher({ location }) {
  yield put(push(location))
}

function* locationReplacer({ location }) {
  yield put(replace(location))
}

function* locationWatcher() {
  yield all([
    takeEvery(PUSH_LOCATION, locationPusher),
    takeEvery(REPLACE_LOCATION, locationReplacer)
  ])
}

export const saga = [locationWatcher()]



// WEBPACK FOOTER //
// ./src/store/location.js